/* eslint-disable */
import axios from 'axios';
import Cookies from 'js-cookie';
import { NOTIFICATIONS_API_URL } from '../lib/environment.js';

import { newAbortSignalFunc } from './modules/api.js';

const timeoutAmount = 180000; //Aborts request after 30 seconds

// Create a dedicated axios instance for external notifications API (no app interceptors)
const notificationsAxios = axios.create({
	timeout: 30000,
	headers: {
		'Content-Type': 'application/json',
	},
});

// Add auth token interceptor
notificationsAxios.interceptors.request.use((config) => {
	const bayToken = Cookies.get('bayToken');
	if (bayToken) {
		config.headers.Authorization = `Bearer ${bayToken}`;
	}
	return config;
});

// Consolidated mock data for email editor blocks
const MOCK_DATA = {
	// Sample listings data (consolidated from various sources)
	listings: [
		{
			id: '1',
			title: '123 Main St',
			address: '123 Main St',
			city: 'New York',
			state: 'NY',
			zip: '10001',
			list_price: 350000,
			beds: 3,
			baths: 2,
			sq_foot: 1800,
			image_data: [
				'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=200&h=200&fit=crop',
			],
		},
		{
			id: '2',
			title: '456 Oak Ave',
			address: '456 Oak Ave',
			city: 'Los Angeles',
			state: 'CA',
			zip: '90210',
			list_price: 425000,
			beds: 4,
			baths: 3,
			sq_foot: 2200,
			image_data: [
				'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=200&h=200&fit=crop',
			],
		},
		{
			id: '3',
			title: '789 Pine Rd',
			address: '789 Pine Rd',
			city: 'Chicago',
			state: 'IL',
			zip: '60601',
			list_price: 299000,
			beds: 2,
			baths: 1,
			sq_foot: 1200,
			image_data: [
				'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=200&h=200&fit=crop',
			],
		},
		{
			id: '4',
			title: '321 Elm Street',
			address: '321 Elm Street',
			city: 'Miami',
			state: 'FL',
			zip: '33101',
			list_price: 475000,
			beds: 3,
			baths: 2,
			sq_foot: 1650,
			image_data: [
				'https://images.unsplash.com/photo-1520637836862-4d197d17c91a?w=200&h=200&fit=crop',
			],
		},
		{
			id: '5',
			title: '567 Maple Ave',
			address: '567 Maple Ave',
			city: 'Seattle',
			state: 'WA',
			zip: '98101',
			list_price: 525000,
			beds: 4,
			baths: 3,
			sq_foot: 2400,
			image_data: [
				'https://images.unsplash.com/photo-1551818255-e6e10975bc17?w=200&h=200&fit=crop',
			],
		},
	],

	// Sample users/agents data (consolidated from various sources)
	users: [
		{
			id: '1',
			name: 'John Smith',
			address: '123 Real Estate Blvd, Suite 100, Anytown, CA 90210',
			licenceNumber: 'DRE# 12345678',
			phone: '(555) 123-4567',
			title: 'Senior Realtor',
			email: 'john.smith@realestate.com',
			profileImage:
				'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop&crop=face',
		},
		{
			id: '2',
			name: 'Sarah Johnson',
			address: '456 Property Lane, Suite 200, Los Angeles, CA 90024',
			licenceNumber: 'DRE# 87654321',
			phone: '(555) 234-5678',
			title: 'Broker Associate',
			email: 'sarah.johnson@realestate.com',
			profileImage:
				'https://images.unsplash.com/photo-1494790108755-2616b9b01d1a?w=200&h=200&fit=crop&crop=face',
		},
		{
			id: '3',
			name: 'Michael Chen',
			address: '789 Realty Ave, Floor 3, Chicago, IL 60611',
			licenceNumber: 'LIC# 11223344',
			phone: '(555) 345-6789',
			title: 'Commercial Broker',
			email: 'michael.chen@realestate.com',
			profileImage:
				'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&crop=face',
		},
		{
			id: '4',
			name: 'Emily Davis',
			address: '321 Home Street, Suite 50, Miami, FL 33101',
			licenceNumber: 'FL# 55667788',
			phone: '(555) 456-7890',
			title: 'Luxury Specialist',
			email: 'emily.davis@realestate.com',
			profileImage:
				'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop&crop=face',
		},
		{
			id: '5',
			name: 'Robert Wilson',
			address: '654 Investment Pkwy, Austin, TX 78701',
			licenceNumber: 'TX# 99887766',
			phone: '(555) 567-8901',
			title: 'Investment Advisor',
			email: 'robert.wilson@realestate.com',
			profileImage:
				'https://images.unsplash.com/photo-1556157382-97eda2d62296?w=200&h=200&fit=crop&crop=face',
		},
	],

	// Layout options for listings
	listingLayouts: [
		{ id: 'grid', name: 'Grid Layout' },
		{ id: 'list', name: 'List Layout' },
		{ id: 'card', name: 'Card Layout' },
		{ id: 'compact', name: 'Compact Layout' },
	],

	// Layout options for users
	userLayouts: [
		{ id: 'stacked', name: 'Stacked Layout' },
		{ id: 'side-by-side', name: 'Side by Side Layout' },
		{ id: 'card', name: 'Card Layout' },
		{ id: 'minimal', name: 'Minimal Layout' },
	],

	// Criteria mock data for listings (from CriteriaDrawer)
	criteriaListings: [
		{
			id: 'criteria-1',
			address: '456 Criteria St',
			city: 'Los Angeles',
			state: 'CA',
			zip: '90210',
			list_price: 650000,
			beds: 3,
			baths: 2,
			sq_foot: 2100,
			image_data: [
				'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=200&h=200&fit=crop',
			],
		},
		{
			id: 'criteria-2',
			address: '789 Filter Ave',
			city: 'New York',
			state: 'NY',
			zip: '10001',
			list_price: 850000,
			beds: 2,
			baths: 2,
			sq_foot: 1800,
			image_data: [
				'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=200&h=200&fit=crop',
			],
		},
		{
			id: 'criteria-3',
			address: '321 Search Blvd',
			city: 'Chicago',
			state: 'IL',
			zip: '60601',
			list_price: 425000,
			beds: 4,
			baths: 3,
			sq_foot: 2500,
			image_data: [
				'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=200&h=200&fit=crop',
			],
		},
	],
};

const emailEditor = () => {
	return {
		// NOTE: type could be listings or users/agents
		fetchLayouts: async ({ type, id }) => {
			return new Promise((resolve, reject) => {
				// Comment out axios call until endpoints are ready
				// axios({
				//   url: `/getSomeLayouts?type=${type}&id=${id}`,
				//   method: 'GET',
				//   timeout: timeoutAmount,
				//   signal: newAbortSignalFunc(),
				// })

				// Simulate API delay
				setTimeout(() => {
					const layouts =
						type === 'listings'
							? MOCK_DATA.listingLayouts
							: MOCK_DATA.userLayouts;
					resolve({
						data: layouts,
						status: 0,
						message: 'success',
					});
				}, 500);
			});
		},

		fetchListings: async (
			rootPath,
			queryParams,
			limit = 10,
			offset = 0,
			sort,
			entryType,
		) => {
			return new Promise((resolve, reject) => {
				// Comment out axios call until endpoints are ready
				// axios({
				//   url: '/getSomeListings',
				//   method: 'GET',
				//   timeout: timeoutAmount,
				//   signal: newAbortSignalFunc(),
				// })

				// Simulate API delay
				setTimeout(() => {
					const startIndex = offset;
					const endIndex = startIndex + limit;
					const paginatedListings = MOCK_DATA.listings.slice(
						startIndex,
						endIndex,
					);

					resolve({
						data: {
							listings: paginatedListings,
							total: MOCK_DATA.listings.length,
							page: Math.floor(offset / limit) + 1,
							totalPages: Math.ceil(MOCK_DATA.listings.length / limit),
						},
						status: 0,
						message: 'success',
					});
				}, 800);
			});
		},

		fetchUsers: async (
			rootPath,
			queryParams,
			limit = 10,
			offset = 0,
			sort,
			entryType,
		) => {
			return new Promise((resolve, reject) => {
				// Comment out axios call until endpoints are ready
				// axios({
				//   url: '/getSomeUsers',
				//   method: 'GET',
				//   timeout: timeoutAmount,
				//   signal: newAbortSignalFunc(),
				// })

				// Simulate API delay
				setTimeout(() => {
					const startIndex = offset;
					const endIndex = startIndex + limit;
					const paginatedUsers = MOCK_DATA.users.slice(startIndex, endIndex);

					resolve({
						data: {
							users: paginatedUsers,
							total: MOCK_DATA.users.length,
							page: Math.floor(offset / limit) + 1,
							totalPages: Math.ceil(MOCK_DATA.users.length / limit),
						},
						status: 0,
						message: 'success',
					});
				}, 800);
			});
		},

		fetchAgents: async (
			rootPath,
			queryParams,
			limit = 10,
			offset = 0,
			sort,
			entryType,
		) => {
			return new Promise((resolve, reject) => {
				// Comment out axios call until endpoints are ready
				// axios({
				//   url: '/getSomeAgents',
				//   method: 'GET',
				//   timeout: timeoutAmount,
				//   signal: newAbortSignalFunc(),
				// })

				// Simulate API delay (agents are same as users for now)
				setTimeout(() => {
					const startIndex = offset;
					const endIndex = startIndex + limit;
					const paginatedAgents = MOCK_DATA.users.slice(startIndex, endIndex);

					resolve({
						data: {
							agents: paginatedAgents,
							total: MOCK_DATA.users.length,
							page: Math.floor(offset / limit) + 1,
							totalPages: Math.ceil(MOCK_DATA.users.length / limit),
						},
						status: 0,
						message: 'success',
					});
				}, 800);
			});
		},

		fetchListingsCriteria: async (formValuesObject) => {
			return new Promise((resolve, reject) => {
				// Comment out axios call until endpoints are ready
				// axios({
				//   url: '/getSomeListingsCriteria',
				//   method: 'POST',
				//   timeout: timeoutAmount,
				//   signal: newAbortSignalFunc(),
				//   data: formValuesObject,
				// })

				// Simulate API delay for criteria search
				setTimeout(() => {
					// Filter mock criteria listings based on form values
					let filteredListings = [...MOCK_DATA.criteriaListings];

					// Simple filtering based on criteria (in real implementation, backend would handle this)
					if (formValuesObject.minPrice) {
						filteredListings = filteredListings.filter(
							(listing) => listing.list_price >= formValuesObject.minPrice,
						);
					}
					if (formValuesObject.maxPrice) {
						filteredListings = filteredListings.filter(
							(listing) => listing.list_price <= formValuesObject.maxPrice,
						);
					}
					if (formValuesObject.beds) {
						filteredListings = filteredListings.filter(
							(listing) => listing.beds >= formValuesObject.beds,
						);
					}
					if (formValuesObject.city) {
						filteredListings = filteredListings.filter((listing) =>
							listing.city
								.toLowerCase()
								.includes(formValuesObject.city.toLowerCase()),
						);
					}

					resolve({
						data: {
							results: filteredListings,
							total: filteredListings.length,
							appliedCriteria: formValuesObject,
						},
						status: 0,
						message: 'success',
					});
				}, 1500);
			});
		},

		fetchUsersCriteria: async (formValuesObject) => {
			return new Promise((resolve, reject) => {
				// Comment out axios call until endpoints are ready
				// axios({
				//   url: '/getSomeUsersCriteria',
				//   method: 'POST',
				//   timeout: timeoutAmount,
				//   signal: newAbortSignalFunc(),
				//   data: formValuesObject,
				// })

				// Simulate API delay for user criteria search
				setTimeout(() => {
					// Filter mock users based on form values
					let filteredUsers = [...MOCK_DATA.users];

					// Simple filtering based on criteria (in real implementation, backend would handle this)
					if (
						formValuesObject.userType &&
						formValuesObject.userType.length > 0
					) {
						// For demo, assume userType filters by title keywords
						filteredUsers = filteredUsers.filter((user) =>
							formValuesObject.userType.some((type) =>
								user.title.toLowerCase().includes(type.toLowerCase()),
							),
						);
					}
					if (
						formValuesObject.performanceType &&
						formValuesObject.performanceType.length > 0
					) {
						// For demo, performanceType doesn't filter (would need performance data)
						// In real implementation, this would filter by sales performance metrics
					}

					resolve({
						data: {
							users: filteredUsers,
							total: filteredUsers.length,
							appliedCriteria: formValuesObject,
						},
						status: 0,
						message: 'success',
					});
				}, 1500);
			});
		},

		sendTestEmail: async (
			emailAddresses,
			htmlContent,
			subject = 'Test Email',
			userName = 'BAY Email Editor',
			userEmail = 'noreply@backatyou.com',
		) => {
			// Validate inputs
			if (!emailAddresses || emailAddresses.length === 0) {
				throw new Error('No email addresses provided');
			}

			if (!htmlContent) {
				throw new Error('No HTML content provided');
			}

			// Build recipients array
			const recipients = emailAddresses.map((email) => ({
				email: email.trim(),
				data: {},
			}));

			// Build request payload for notifications API
			const payload = {
				channels: ['email'],
				priority: 1,
				metadata: {
					sourceService: 'ui-design',
				},
				sender: {
					email: userEmail,
					name: userName,
				},
				content: {
					subject: subject,
					message: {
						email: htmlContent,
					},
					data: {},
				},
				recipients,
			};

			try {
				const response = await notificationsAxios.post(
					`${NOTIFICATIONS_API_URL}/v1/messages`,
					payload,
				);

				// Extract response data
				const responseData = response.data?.result || response.data;

				return {
					success: true,
					data: {
						sent: emailAddresses.length,
						recipients: emailAddresses,
						timestamp: new Date().toISOString(),
						requestId: responseData?.requestId,
						queuedAt: responseData?.queuedAt,
						status: responseData?.status,
					},
					status: 0,
					message: `Test email queued successfully for ${emailAddresses.length} recipient(s)`,
				};
			} catch (error) {
				console.error('❌ Failed to send test email:', error);

				// Structure error response
				const errorMessage =
					error?.response?.data?.message ||
					error?.message ||
					'Failed to send test email';

				return {
					success: false,
					data: null,
					status: 1,
					message: errorMessage,
					error: {
						code: error?.response?.status,
						details: error?.response?.data,
					},
				};
			}
		},
	};
};

const singleton = emailEditor();
Object.freeze(singleton);

export default emailEditor;
